import { TonConnect, TonConnectUIProvider } from '@tonconnect/ui-react';
import { PropsWithChildren } from 'react';

const connector = new TonConnect();

function WalletProvider({ children }: PropsWithChildren) {
  return (
    <TonConnectUIProvider
      connector={connector}
      restoreConnection
      actionsConfiguration={{
        twaReturnUrl: process.env.REACT_APP_WEBAPP_URL as `${string}://${string}`,
      }}
    >
      {children}
    </TonConnectUIProvider>
  );
}

export default WalletProvider;
